import React, { memo } from "react";
import { Box, Typography } from "@material-ui/core";
import MicOffIcon from "@material-ui/icons/MicOff";

interface VideoParticipantProps {
  userId: string;
  displayName: string;
  isLocal?: boolean;
  audioMuted?: boolean;
  videoOn?: boolean;
  isMainView?: boolean;
  isSmallView?: boolean;
}

const VideoParticipant = memo(
  ({
    userId,
    displayName,
    isLocal = false,
    audioMuted = false,
    videoOn = true,
    isMainView = false,
    isSmallView = false
  }: VideoParticipantProps) => {
    const elementId = isLocal ? undefined : `remote-video-${userId}`;

    const getContainerClass = () => {
      if (isMainView) return "zoom-main-video-container";
      if (isSmallView) return "zoom-small-video-container";
      return "zoom-video-main-item";
    };

    const getLabelClass = () => {
      if (isMainView) return "zoom-main-video-label";
      if (isSmallView) return "zoom-small-video-label";
      return "zoom-video-label-overlay";
    };

    const getMutedClass = () => {
      if (isMainView) return "zoom-main-muted-indicator";
      if (isSmallView) return "zoom-small-muted-indicator";
      return "zoom-muted-indicator";
    };

    return (
      <Box className={getContainerClass()}>
        <video-player-container
          id={elementId}
          ref={isLocal ? undefined : null}
          style={{ width: "100%", height: "100%" }}
        ></video-player-container>
        <Typography variant="caption" className={getLabelClass()}>
          {displayName}
          {isLocal ? " (You)" : ""}
        </Typography>
        {audioMuted && (
          <Box className={getMutedClass()}>
            <MicOffIcon
              style={{ color: "white", fontSize: isSmallView ? 16 : 20 }}
            />
          </Box>
        )}
      </Box>
    );
  }
);

export default VideoParticipant;
